import { render, staticRenderFns } from "./ReportDesktop.vue?vue&type=template&id=bdf6e93e"
import script from "./ReportDesktop.vue?vue&type=script&lang=js"
export * from "./ReportDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports